import type { PrintLabelResult } from '@techgitter/contracts';

export interface PrintFeedback {
  severity: 'success' | 'warning';
  message: string;
}

/**
 * The toast for a finished print request. A `skipped` result is a warning,
 * not a success: the API answered, but nothing is coming out of the printer
 * (usually no printer is configured for the lane), and that must not read as
 * "sent".
 */
export function printFeedback(what: string, result: PrintLabelResult): PrintFeedback {
  if (result.skipped || !result.published) {
    return {
      severity: 'warning',
      message: `Print skipped: ${result.reason ?? 'printer not configured'}`,
    };
  }
  return {
    severity: 'success',
    message: `${what} sent to printer${result.jobId ? ` (job ${result.jobId.slice(0, 8)})` : ''}`,
  };
}
